import { render, staticRenderFns } from "./product-brands-v2.modal.vue?vue&type=template&id=3ba2477e&scoped=true"
import script from "./product-brands-v2.modal.vue?vue&type=script&lang=js"
export * from "./product-brands-v2.modal.vue?vue&type=script&lang=js"
import style0 from "./product-brands-v2.modal.vue?vue&type=style&index=0&id=3ba2477e&prod&lang=scss&scoped=true"
import style1 from "./product-brands-v2.modal.vue?vue&type=style&index=1&id=3ba2477e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba2477e",
  null
  
)

export default component.exports